import React from 'react';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import MatchedVanpools from './MatchedVanpools';
import TellUsAboutCommute from '../tell-us-about-commute/TellUsAboutCommute';
import { initialJoinCommuteState } from '../JoinCommuteReducer';
import NoVansComponent from '../no-vans/NoVansComponent';
import Loading from '../../shared/loading/Loading';
import analyticsService from '../../shared/analytics/analytics-service';
import { GET_MATCHING_VANPOOLS, LOADER_ACTIVE, RESET_EDIT_COMMUTE_INFO, SET_SELECTED_VAN, SET_USER_COMMUTE_DATA, VAN_LIST_UPDATED,UPDATE_HOME_WORK_ADDRESS_PREFERRED_VANPOOL, UPDATE_START_DATE } from '../../redux/actionTypes';
import { getVanAvailableDays } from '../helpers/commonHelper';
import { isEqual } from 'lodash';
import { getVanPrice, getTraditionalVanPrice } from '../helpers/vanHelpers';


function ViewMatchingVans(props) {

  const [populateEditCommuteData, setPopulateEditCommuteData] = useState(true);
  const [isCoordinatorInvite, setIsCoordinatorInvite] = useState(false);
  const [enabledDays, updateEnabledDays] = useState([]);

  function updateComponent(data) {
    props.updateLoading(true);
    if(props.joinCommuteState.isCoordinatorInvite){
      data = {
        ...data,
        inviteId: props.joinCommuteState.inviteId
      }
    }
    props.setUserCommuteData(data);
    var fromUpdateButton = true;
    props.getMatchingVanpools(props.history,fromUpdateButton);
    var activeDays = Object.keys(data.rosterDays).filter(el => data.rosterDays[el] == true);
    var daysString = activeDays.map(d => d.substring(0, 2)).join(".").toLowerCase()
    analyticsService.analyticsProcessEvent({
      "event": "edit_commute_click_update",
      "context": {
        "event_action": "update",
        "event_detail": {
          "days_selected": daysString,
          "arrival_flexibility": data.flexArrivalMinutes,
          "departure_flexibility": data.flexDepartureMinutes,
        }
      }
    });
  }

  function callAnalyticswithVanpools() {
    var userPackage = props.joinCommuteState?.userCommuteData?.package;
    var userRole = props.joinCommuteState?.drivingScheduleData?.isDesiredDriverRole;
    var vanpoolsArray = [];
    props.matchingVans.map(van => {
      var price = van.isSubscriptionVanpool ? getVanPrice(van,userRole,userPackage) : van.isIPB ? null : getTraditionalVanPrice(van);
        var obj = {
          "vanpoolID" : van.vanpoolId,
          "displayedPrice" : price && price.totalAmount ? price.totalAmount : null,
          "isOptimalMatch" : van.isOptimalMatch
      }
      vanpoolsArray.push(obj)
    });
    analyticsService.getPageName({
      "pagename": "matching vans/results",
      "process": "matching vans",
      "vanpools": vanpoolsArray
    })
  }

  useEffect(() => {
    if (isEqual(props.joinCommuteData, initialJoinCommuteState)) {
      props.history.push("/JoinCommute");
    }
    if(props.matchingVans && props.matchingVans.length){
      callAnalyticswithVanpools();
    }
    if (!props.joinCommuteState.inviteId) {
      if (!props.joinCommuteState.vanListUpdated) {
        props.updateLoading(true);
        props.getMatchingVanpools(props.history);
      }
      if (props.joinCommuteState.userCommuteData.isUpdated) {
        props.updateLoading(true);
        props.getMatchingVanpools(props.history);
        props.vanListUpdated();
      }
    }
  }, [])

  useEffect(() => {
    if (props.joinCommuteState && props.joinCommuteState.inviteId) {
      const preferredVanpool = props.joinCommuteState.matchingVans.filter(van => van.isPreferredVanpool);
        if(preferredVanpool && preferredVanpool.length > 0){
          var homeAddress = preferredVanpool[0].originAddress;
          var workAddress = preferredVanpool[0].destinationAddress;
          props.updateHomeWorkAddress(homeAddress,workAddress);
        }
    }
    if(props.joinCommuteState.updatelist && props.matchingVans && props.matchingVans.length){
      callAnalyticswithVanpools();
    }
  }, [props.matchingVans])

  useEffect(() => {
    if (props.joinCommuteState && props.joinCommuteState.inviteId) {
      if (props.joinCommuteState.isInviteError === true) {
        setPopulateEditCommuteData(false);
      } else {
        setPopulateEditCommuteData(true);
        if (props.joinCommuteState.isCoordinatorInvite) {
          setIsCoordinatorInvite(true);
          const preferredVanpool = props.joinCommuteState.matchingVans.filter(van => van.isPreferredVanpool);
          if (preferredVanpool && preferredVanpool.length > 0) {
            const availableDays = getVanAvailableDays(preferredVanpool[0].operationalDays);
            updateEnabledDays(availableDays);
          }
        }
      }
    }
  }, [props.joinCommuteState])

  useEffect(() => {
    analyticsService.pageInfo("matching vans");
  });

  function goToJoinCommute() {
    analyticsService.analyticsProcessEvent({
      "event": "click_generic",
      "context": {
        "event_action": "find a new route"
      }
    });
    props.history.push("/JoinCommute");
  }

  function goToStayInTouch() {
    analyticsService.pageInfo("stay in touch");
    analyticsService.analyticsProcessEvent({
      "event": "stay_in_touch_click_continue",
      "context": {
        "event_action": "stay in touch"
      }
    });
    props.history.push("/JoinCommute/stay-in-touch");
  }

  return (
    <div className='vans-container'>
      <span aria-live='polite' role='alert'>
        <Loading isLoading={props.loading} />
      </span>
      {props.matchingVans.length > 0 || props.joinCommuteState.inviteId ?
        <div className='view-matching-vans-container'>
          <div className="update-commute" role='group'>
            <div className='heading'>Edit my commute</div>
            <TellUsAboutCommute
              continueClicked={updateComponent}
              buttonText="UPDATE"
              flow='editCommute'
              prePopulateData={populateEditCommuteData}
              disableEditCommute={isCoordinatorInvite}
              enabledDays={enabledDays}
            />
          </div>
          <MatchedVanpools
            props={props}
            matchingVans={props.matchingVans}
            goToStayInTouch={goToStayInTouch}
            userInfo={props.joinCommuteState}
            setSelectedVan={props.setSelectedVan}
            resetEditCommuteSettings={props.resetEditCommuteSettings}
            isCoordinatorInvite={isCoordinatorInvite}
            updateStartDate={props.updateStartDate} />
        </div> : <NoVansComponent goToJoinCommute={goToJoinCommute} goToStayInTouch={goToStayInTouch} isLoading={props.loading} />
      }
    </div>
  );
}

function mapStateToProps(state) {
  return {
    joinCommuteState: state.joinCommute,
    matchingVans: state.joinCommute.matchingVans,
    loading: state.joinCommute.loading
  }
}
function mapDispatchToProps(dispatch) {
  return {
    setUserCommuteData(data) {
      dispatch({ type: SET_USER_COMMUTE_DATA, data });
    },
    getMatchingVanpools(history,updatelist) {
      dispatch({ type: GET_MATCHING_VANPOOLS, history,updatelist })
    },
    updateLoading(data) {
      dispatch({ type: LOADER_ACTIVE, data });
    },
    vanListUpdated() {
      dispatch({ type: VAN_LIST_UPDATED });
    },
    setSelectedVan(van) {
      dispatch({ type: SET_SELECTED_VAN, data: van })
    },
    resetEditCommuteSettings() {
      dispatch({ type: RESET_EDIT_COMMUTE_INFO });
    },
    updateHomeWorkAddress(homeAddress,workAddress) {
      dispatch({type: UPDATE_HOME_WORK_ADDRESS_PREFERRED_VANPOOL, data:{homeAddress,workAddress}})
    },
    updateStartDate(date) {
      dispatch({ type: UPDATE_START_DATE, data: date });
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewMatchingVans)